import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import classes from './PieChartCard.module.css';

const COLORS = [
  '#002b44', '#1d4e7a', '#2563a8', '#0077b6',
  '#6a9dfa', '#0096c7', '#00b4d8', '#93c5fd', '#bfdbfe',
];

function CustomTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const { symbol, percentage, volume } = payload[0].payload;
  return (
    <div className={classes.tooltip}>
      <strong>{symbol}</strong>
      <span>{percentage}%</span>
      <span className={classes.tooltipVol}>Vol: {volume.toLocaleString()}</span>
    </div>
  );
}

export default function PieChartCard({ data = [] }) {
  if (!data.length) {
    return (
      <div className={classes.card}>
        <div className={classes.placeholder}>No data</div>
      </div>
    );
  }

  return (
    <div className={classes.card}>
      <ResponsiveContainer width="100%" height={280}>
        <PieChart>
          <Pie
            data={data}
            dataKey="percentage"
            nameKey="symbol"
            cx="50%"
            cy="50%"
            outerRadius={110}
          >
            {data.map((entry, i) => (
              <Cell key={entry.symbol} fill={COLORS[i % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend formatter={(value) => <span style={{ fontSize: '0.85rem' }}>{value}</span>} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
